import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React, { useMemo } from 'react';
import { v4 } from 'uuid';
import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';
import './C2RadioButtonGroup.css.js';

const C2RadioButtonGroup = (_a) => {
    var { className, disabled, id, inline, onChange, options, optionDisabled = "disabled", optionLabel = "label", optionValue = "value", value } = _a, otherProps = __rest(_a, ["className", "disabled", "id", "inline", "onChange", "options", "optionDisabled", "optionLabel", "optionValue", "value"]);
    const componentId = useMemo(() => v4(), []);
    return (React.createElement("div", Object.assign({ className: classNames("c2-radio-button-group", { "c2-radio-button-group--inline": inline }, className), id: id !== null && id !== void 0 ? id : "" }, otherProps), options === null || options === void 0 ? void 0 : options.map((option, index) => {
        const inputDisabled = getInputDisabled(option);
        const inputLabel = getInputLabel(option);
        const inputValue = getInputValue(option);
        const inputId = `${componentId}-${inputValue}-${index}`;
        return (React.createElement("div", { className: "field-radiobutton" },
            React.createElement(RadioButton, { checked: value === inputValue, disabled: disabled || inputDisabled, inputId: inputId, key: index, name: componentId, onChange: onChange, value: inputValue }),
            React.createElement("label", { htmlFor: inputId }, inputLabel)));
    })));
    function getInputDisabled(option) {
        if (option != null && typeof option === "object" && optionDisabled) {
            // @ts-expect-error
            return option[optionDisabled];
        }
        return false;
    }
    function getInputLabel(option) {
        switch (typeof option) {
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "symbol":
                return option.toString();
            case "function":
            case "undefined":
                return "";
            case "object":
                // @ts-expect-error
                return option == null ? "" : option[optionLabel];
            default:
                return "";
        }
    }
    function getInputValue(option) {
        switch (typeof option) {
            case "object":
                // @ts-expect-error
                return option == null || !optionValue ? option : option[optionValue];
            default:
                return option;
        }
    }
};

export { C2RadioButtonGroup as default };
//# sourceMappingURL=C2RadioButtonGroup.js.map
